function doInteractionTask(callback: () => void) {
    callback();
    return null;
}

export default doInteractionTask;
